import { FC } from "react"
import {
    TablerIconsProps,
    IconBuildingBroadcastTower,
    IconTerminal,
    IconClockCog,
    IconCamera,
    IconBolt,
    IconClockBolt,
    IconActivity,
    IconBulb,
} from "@tabler/icons-react"
import { Locator } from "../../../../contexts/language-context"

export default {
    mqtt: { getLabel: L => L("MQTT"), icon: IconBuildingBroadcastTower },
    cl: { getLabel: L => L("CL"), icon: IconTerminal },
    periodictask: { getLabel: L => L("Periodic tasks"), icon: IconClockBolt },
    camera: { getLabel: L => L("Camera"), icon: IconCamera },
    trigger: { getLabel: L => L("Trigger"), icon: IconBolt },
    wittypi: { getLabel: L => L("Time schedule"), icon: IconClockCog },
    health: { getLabel: L => L("Activity"), icon: IconActivity },
    lights: { getLabel: L => L("LED lights"), icon: IconBulb },
} satisfies Record<string, { getLabel: (L: Locator) => string; icon: FC<TablerIconsProps> }>
